// 小虎看番 · 番剧数据
export interface AnimeItem {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  genres: string[];
  rating: number;
  year: number;
  episodes: string;
  status: "完结" | "连载中";
  cover: string;
  description: string;
  tags: string[];
}

export interface Category {
  id: string;
  name: string;
  short: string;
  path: string;
  tagline: string;
  color: "primary" | "accent" | "secondary";
}

export const categories: Category[] = [
  {
    id: "hot",
    name: "高分番排行榜",
    short: "高分番",
    path: "/list/hot",
    tagline: "口碑封神，闭眼入的必看经典",
    color: "primary",
  },
  {
    id: "hidden",
    name: "冷门佳作",
    short: "冷门佳作",
    path: "/list/hidden",
    tagline: "藏在角落的宝藏，挖到就是赚到",
    color: "secondary",
  },
  {
    id: "finished",
    name: "完结番合集",
    short: "完结番",
    path: "/list/finished",
    tagline: "一次看个痛快，不用等更",
    color: "accent",
  },
  {
    id: "allnight",
    name: "熬夜补番清单",
    short: "熬夜补番",
    path: "/list/allnight",
    tagline: "停不下来的上头之作，小心看通宵",
    color: "primary",
  },
];

export const animeList: AnimeItem[] = [
  // —— 高分番排行榜 ——
  {
    id: "fmab",
    title: "钢之炼金术师 FA",
    titleEn: "Fullmetal Alchemist: Brotherhood",
    category: "hot",
    genres: ["冒险", "奇幻", "剧情"],
    rating: 9.8,
    year: 2009,
    episodes: "64 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20young%20alchemist%20with%20steel%20armor%20in%20a%20warm%20desert%20city%2C%20epic%20fantasy%20adventure%2C%20warm%20golden%20and%20orange%20tone%2C%20detailed%20cel%20shading%2C%20dramatic%20lighting%2C%20storybook%20illustration&width=600&height=900&seq=xh-fmab&orientation=portrait",
    description:
      "为了取回失去的身体，兄弟二人踏上寻找贤者之石的旅程。烧瓶中的小人、等价交换的法则，以及那段跨越战争的漫长悲歌——被无数人称为「零差评神作」的剧情巅峰。",
    tags: ["神作", "剧情", "燃", "热血"],
  },
  {
    id: "aot",
    title: "进击的巨人",
    titleEn: "Attack on Titan",
    category: "hot",
    genres: ["战斗", "悬疑", "黑暗奇幻"],
    rating: 9.5,
    year: 2013,
    episodes: "共 4 季",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20soldier%20in%20brown%20uniform%20standing%20before%20giant%20city%20walls%2C%20military%20dark%20fantasy%2C%20warm%20amber%20and%20muted%20teal%20tone%2C%20dramatic%20anime%20illustration%2C%20epic%20scale&width=600&height=900&seq=xh-aot&orientation=portrait",
    description:
      "城墙之内的人类被巨人所困，一个少年以自由之名举起刀刃。宏大的世界观、环环相扣的真相，以及那句「献出你的心脏」，成为一代人的集体记忆。",
    tags: ["封神", "反转", "燃", "深刻"],
  },
  {
    id: "steins",
    title: "命运石之门",
    titleEn: "Steins;Gate",
    category: "hot",
    genres: ["科幻", "悬疑", "时间旅行"],
    rating: 9.4,
    year: 2011,
    episodes: "24 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20young%20scientist%20in%20white%20lab%20coat%20holding%20a%20retro%20phone%20against%20a%20clockwork%20background%2C%20time%20travel%20sci-fi%2C%20warm%20orange%20and%20crimson%20tone%2C%20intricate%20anime%20illustration&width=600&height=900&seq=xh-steins&orientation=portrait",
    description:
      "一个自称「疯狂科学家」的少年，意外发明了能向过去发送短信的时间机器。越是试图拯救，命运越走向不可挽回的绝望，直到那条唯一的「世界线」出现。",
    tags: ["科幻", "神作", "催泪", "慢热"],
  },
  {
    id: "violet",
    title: "紫罗兰永恒花园",
    titleEn: "Violet Evergarden",
    category: "hot",
    genres: ["治愈", "剧情", "奇幻"],
    rating: 9.2,
    year: 2018,
    episodes: "13 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20blonde%20girl%20in%20an%20elegant%20vintage%20dress%20with%20golden%20brooch%20under%20soft%20sunlight%2C%20healing%20romantic%20anime%2C%20warm%20golden%20and%20rose%20tone%2C%20delicate%20watercolor%20style%20illustration&width=600&height=900&seq=xh-violet&orientation=portrait",
    description:
      "战争结束后，曾是杀人兵器的少女成为「自动手记人偶」，替人书写信件。在为他人传达爱意的过程中，她终于明白了「我爱你」这三个字的分量。",
    tags: ["治愈", "催泪", "画面美", "深情"],
  },
  {
    id: "deathnote",
    title: "死亡笔记",
    titleEn: "Death Note",
    category: "hot",
    genres: ["悬疑", "犯罪", "智斗"],
    rating: 9.1,
    year: 2006,
    episodes: "37 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20dark%20notebook%20with%20a%20mysterious%20shinigami%20shadow%20and%20a%20youth%20with%20messy%20hair%2C%20thriller%20mystery%20anime%2C%20warm%20crimson%20and%20charcoal%20tone%2C%20dramatic%20high%20contrast%20illustration&width=600&height=900&seq=xh-deathnote&orientation=portrait",
    description:
      "一本写上名字就能取人性命的笔记本，让一个天才少年成为「新世界的神」。与另一位天才侦探的世纪对决，把智斗推向极致，全程高能。",
    tags: ["烧脑", "智斗", "经典", "暗黑"],
  },
  {
    id: "haikyuu",
    title: "排球少年",
    titleEn: "Haikyuu!!",
    category: "hot",
    genres: ["运动", "热血", "青春"],
    rating: 9.3,
    year: 2014,
    episodes: "共 4 季",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20short%20energetic%20volleyball%20player%20jumping%20to%20spike%20a%20ball%20in%20an%20orange%20gym%2C%20sports%20anime%2C%20dynamic%20action%2C%20warm%20orange%20and%20yellow%20tone%2C%20vibrant%20illustration&width=600&height=900&seq=xh-haikyuu&orientation=portrait",
    description:
      "身高不占优的翔阳，遇上了「球场上的王者」影山，两人组成搭档冲击全国大赛。没有超能力，只有汗水与热爱，是近年来最纯粹的热血运动番。",
    tags: ["热血", "运动", "青春", "治愈"],
  },

  // —— 冷门佳作 ——
  {
    id: "hyouka",
    title: "冰菓",
    titleEn: "Hyouka",
    category: "hidden",
    genres: ["推理", "日常", "校园"],
    rating: 8.9,
    year: 2012,
    episodes: "22 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20curious%20boy%20with%20soft%20eyes%20and%20a%20girl%20in%20summer%20school%20uniform%20under%20cherry%20blossoms%2C%20gentle%20mystery%20slice%20of%20life%2C%20warm%20pastel%20and%20mint%20tone%2C%20delicate%20anime%20illustration&width=600&height=900&seq=xh-hyouka&orientation=portrait",
    description:
      "慵懒的「节能主义」少年折木奉太郎，被好奇心旺盛的千反田爱瑠拉着卷入校园悬疑。平淡日常里的暗流涌动，越品越有味道的慢热推理。",
    tags: ["日常", "推理", "慢热", "治愈"],
  },
  {
    id: "mushishi",
    title: "虫师",
    titleEn: "Mushishi",
    category: "hidden",
    genres: ["奇幻", "单元剧", "治愈"],
    rating: 9.2,
    year: 2005,
    episodes: "共 2 季",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20calm%20silver%20haired%20traveler%20with%20green%20eyes%20walking%20through%20a%20misty%20forest%20with%20glowing%20spores%2C%20mystical%20supernatural%20anime%2C%20warm%20olive%20green%20and%20amber%20tone%2C%20serene%20illustration&width=600&height=900&seq=xh-mushishi&orientation=portrait",
    description:
      "世上存在一种既非动物也非植物的「虫」，能带来不可思议的现象。银发旅人虫师银古四处游历，见证一个个与自然、生命和解的温柔故事。",
    tags: ["治愈", "单元剧", "奇幻", "深沉"],
  },
  {
    id: "rakugo",
    title: "昭和元禄落语心中",
    titleEn: "Showa Genroku Rakugo Shinju",
    category: "hidden",
    genres: ["剧情", "人性", "历史"],
    rating: 9.0,
    year: 2016,
    episodes: "共 2 季",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20kimono%20clad%20storyteller%20on%20a%20traditional%20stage%20under%20warm%20theater%20lighting%2C%20taisho%20showa%20era%20drama%2C%20warm%20indigo%20and%20amber%20tone%2C%20elegant%20ukiyo%20inspired%20illustration&width=600&height=900&seq=xh-rakugo&orientation=portrait",
    description:
      "出狱的落语师与昔日天才同门之间的纠葛，以传统落语为舞台，讲述艺术、爱恨与时代的变迁。被低估到令人心疼的成人向叙事神作。",
    tags: ["剧情", "成人向", "时代", "深情"],
  },
  {
    id: "kino",
    title: "奇诺之旅",
    titleEn: "Kino's Journey",
    category: "hidden",
    genres: ["奇幻", "哲学", "单元剧"],
    rating: 8.8,
    year: 2003,
    episodes: "13 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20young%20traveler%20in%20leather%20coat%20riding%20a%20talking%20motorrad%20through%20a%20distant%20fantasy%20landscape%2C%20philosophical%20road%20trip%20anime%2C%20warm%20golden%20hour%20and%20teal%20tone%2C%20serene%20illustration&width=600&height=900&seq=xh-kino&orientation=portrait",
    description:
      "旅人奇诺与会说话的摩托车伙伴在世界各地旅行，每到一个国家只停留三天。用冷静的目光审视善与恶、自由与规则的边界，安静却后劲十足。",
    tags: ["哲理", "公路", "奇幻", "清新"],
  },
  {
    id: "shirobako",
    title: "白箱",
    titleEn: "Shirobako",
    category: "hidden",
    genres: ["职场", "日常", "励志"],
    rating: 8.9,
    year: 2014,
    episodes: "24 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20determined%20young%20production%20assistant%20girl%20with%20clipboard%20surrounded%20by%20drawing%20desks%20and%20animation%20cells%2C%20workplace%20drama%20anime%2C%20warm%20cream%20and%20coral%20tone%2C%20lively%20illustration&width=600&height=900&seq=xh-shirobako&orientation=portrait",
    description:
      "五位高中动画社团的好友，毕业后投身动画业界。以新人制作进行为核心，还原动画制作的台前幕后，是写给所有追梦人的一封情书。",
    tags: ["职场", "励志", "科普", "温暖"],
  },
  {
    id: "gorush",
    title: "黄金神威",
    titleEn: "Golden Kamuy",
    category: "hidden",
    genres: ["冒险", "历史", "美食"],
    rating: 9.0,
    year: 2018,
    episodes: "共 4 季",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20rough%20soldier%20and%20a%20bear%20hat%20in%20snowy%20hokkaido%20wilderness%2C%20historical%20adventure%20anime%2C%20warm%20snowy%20white%20and%20autumn%20orange%20tone%2C%20rugged%20illustration&width=600&height=900&seq=xh-gorush&orientation=portrait",
    description:
      "日俄战争老兵与阿伊努少女结伴，在北海道追寻藏有金块线索的刺青人皮。历史、求生、美食与荒诞搞笑交织，越看越上头的冷门神作。",
    tags: ["冒险", "历史", "搞笑", "硬核"],
  },

  // —— 完结番合集 ——
  {
    id: "slamdunk",
    title: "灌篮高手",
    titleEn: "Slam Dunk",
    category: "finished",
    genres: ["运动", "热血", "青春"],
    rating: 9.4,
    year: 1993,
    episodes: "101 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20red%20haired%20basketball%20boy%20dribbling%20under%20a%20bright%20gymnasium%20spotlight%2C%20retro%20sports%20anime%2C%20warm%20red%20and%20orange%20tone%2C%20dynamic%2090s%20style%20illustration&width=600&height=900&seq=xh-slamdunk&orientation=portrait",
    description:
      "「我是天才！」樱木花道从门外汉到篮球健将的逆袭之路。一句「教练，我想打篮球」感动了整整一代人，青春的汗水与遗憾都在这里。",
    tags: ["经典", "热血", "青春", "感动"],
  },
  {
    id: "gintama",
    title: "银魂",
    titleEn: "Gintama",
    category: "finished",
    genres: ["搞笑", "热血", "日常"],
    rating: 9.3,
    year: 2006,
    episodes: "共 4 季",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20silver%20haired%20samurai%20with%20wooden%20sword%20in%20an%20edo%20town%2C%20comedy%20action%20anime%2C%20warm%20orange%20and%20crimson%20tone%2C%20playful%20stylized%20illustration&width=600&height=900&seq=xh-gintama&orientation=portrait",
    description:
      "废柴武士银时开了一间万事屋，处理各种鸡毛蒜皮。前一秒还在无厘头搞笑，后一秒就燃到落泪，是「热血搞笑日常」的集大成之作。",
    tags: ["搞笑", "热血", "治愈", "经典"],
  },
  {
    id: "toradora",
    title: "龙与虎",
    titleEn: "Toradora!",
    category: "finished",
    genres: ["恋爱", "校园", "喜剧"],
    rating: 8.9,
    year: 2008,
    episodes: "25 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20tsundere%20small%20girl%20and%20a%20gentle%20boy%20in%20school%20uniforms%20under%20cherry%20blossom%20trees%2C%20romantic%20comedy%20anime%2C%20warm%20rose%20and%20cream%20tone%2C%20soft%20illustration&width=600&height=900&seq=xh-toradora&orientation=portrait",
    description:
      "外表凶悍的「掌中老虎」逢坂大河，与温柔老好人高须龙儿误打误撞成为恋爱战友。圣诞夜的告白名场面，至今仍是恋爱番的教科书。",
    tags: ["恋爱", "校园", "名场面", "治愈"],
  },
  {
    id: "natsume",
    title: "夏目友人帐",
    titleEn: "Natsume's Book of Friends",
    category: "finished",
    genres: ["治愈", "奇幻", "妖怪"],
    rating: 9.1,
    year: 2008,
    episodes: "共 7 季",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20kind%20young%20man%20with%20warm%20smile%20and%20a%20lucky%20cat%20yokai%20walking%20through%20a%20summer%20countryside%2C%20healing%20youkai%20anime%2C%20warm%20green%20and%20golden%20tone%2C%20gentle%20illustration&width=600&height=900&seq=xh-natsume&orientation=portrait",
    description:
      "能看见妖怪的少年夏目贵志，继承了祖母留下的妖怪名册，与招财猫模样的斑一起归还名字。一集一个小故事，温柔得能治愈一整个夏天。",
    tags: ["治愈", "妖怪", "温馨", "治愈向"],
  },
  {
    id: "anohana",
    title: "未闻花名",
    titleEn: "Anohana",
    category: "finished",
    genres: ["剧情", "治愈", "催泪"],
    rating: 8.8,
    year: 2011,
    episodes: "11 话",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20ghost%20girl%20with%20long%20silver%20hair%20sitting%20with%20childhood%20friends%20in%20a%20summer%20field%20of%20flowers%2C%20emotional%20drama%20anime%2C%20warm%20coral%20and%20soft%20blue%20tone%2C%20bittersweet%20illustration&width=600&height=900&seq=xh-anohana&orientation=portrait",
    description:
      "夏天，小时候意外离世的面码回来了，只有仁太能看见她。六个长大成人的伙伴，为了一句「找到你了」重聚。泪点密集到让人停不下来。",
    tags: ["催泪", "友情", "青春", "神ED"],
  },
  {
    id: "hxh",
    title: "全职猎人",
    titleEn: "Hunter x Hunter (2011)",
    category: "finished",
    genres: ["冒险", "战斗", "智斗"],
    rating: 9.4,
    year: 2011,
    episodes: "148 话",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20spiky%20haired%20young%20hunter%20with%20a%20fishing%20rod%20facing%20a%20vast%20unknown%20world%2C%20adventure%20battle%20anime%2C%20warm%20green%20and%20golden%20tone%2C%20detailed%20illustration&width=600&height=900&seq=xh-hxh&orientation=portrait",
    description:
      "少年小杰为寻找父亲踏上猎人之路，结识了奇犽、酷拉皮卡与雷欧力。从考试篇到蚂蚁篇，智斗与战斗的天花板，富坚义博的传奇之作。",
    tags: ["冒险", "智斗", "经典", "燃"],
  },

  // —— 熬夜补番清单 ——
  {
    id: "jjk",
    title: "咒术回战",
    titleEn: "Jujutsu Kaisen",
    category: "allnight",
    genres: ["战斗", "黑暗奇幻", "热血"],
    rating: 9.0,
    year: 2020,
    episodes: "共 2 季",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20dark%20haired%20sorcerer%20student%20in%20a%20high%20collar%20jacket%20surrounded%20by%20blue%20cursed%20energy%2C%20dark%20fantasy%20battle%20anime%2C%20warm%20crimson%20and%20violet%20tone%2C%20dynamic%20illustration&width=600&height=900&seq=xh-jjk&orientation=portrait",
    description:
      "吞下诅咒之王手指的少年虎杖悠仁，进入咒术高专对抗各种咒灵。打斗场面行云流水，涩谷事变篇更是把热血与绝望推到了极致。",
    tags: ["战斗", "燃", "热血", "反转"],
  },
  {
    id: "kimetsu",
    title: "鬼灭之刃",
    titleEn: "Demon Slayer",
    category: "allnight",
    genres: ["战斗", "亲情", "热血"],
    rating: 9.2,
    year: 2019,
    episodes: "共 4 季",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20determined%20boy%20with%20scars%20on%20his%20cheek%20holding%20a%20japanese%20sword%20in%20a%20flame%20lit%20forest%2C%20demon%20slayer%20anime%2C%20warm%20crimson%20and%20black%20tone%2C%20striking%20illustration&width=600&height=900&seq=xh-kimetsu&orientation=portrait",
    description:
      "家人被鬼杀害的炭治郎，为了让变成鬼的妹妹恢复人身而成为鬼杀队剑士。情感刻画细腻，炎柱篇的殉身更是看哭无数人。",
    tags: ["热血", "亲情", "催泪", "名场面"],
  },
  {
    id: "frieren",
    title: "葬送的芙莉莲",
    titleEn: "Frieren: Beyond Journey's End",
    category: "allnight",
    genres: ["奇幻", "治愈", "公路"],
    rating: 9.6,
    year: 2023,
    episodes: "共 2 季",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20silver%20haired%20elf%20mage%20in%20a%20white%20hooded%20cloak%20walking%20through%20a%20sunlit%20forest%20with%20her%20companions%2C%20journey%20fantasy%20anime%2C%20warm%20golden%20and%20soft%20green%20tone%2C%20gentle%20masterpiece%20illustration&width=600&height=900&seq=xh-frieren&orientation=portrait",
    description:
      "打倒魔王的勇者一行回到故乡，精灵法师芙莉莲才发现自己错过了与同伴相处的时光。于是她踏上旅程去「了解人类」，每一集都温柔到心坎里。",
    tags: ["治愈", "神作", "公路", "哲学"],
  },
  {
    id: "oshi",
    title: "我推的孩子",
    titleEn: "Oshi no Ko",
    category: "allnight",
    genres: ["剧情", "偶像", "悬疑"],
    rating: 8.9,
    year: 2023,
    episodes: "共 2 季",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20silver%20haired%20teen%20idol%20star%20with%20sparkling%20eyes%20under%20stage%20spotlights%20with%20petals%2C%20idol%20drama%20anime%2C%20warm%20magenta%20and%20gold%20tone%2C%20glowing%20illustration&width=600&height=900&seq=xh-oshi&orientation=portrait",
    description:
      "以演艺圈为舞台，揭开偶像、演员与星野兄妹背后的爱与复仇。第一集三十分钟的展开震撼全网，行业生态的暗面被扒得淋漓尽致。",
    tags: ["剧情", "反转", "偶像", "神开局"],
  },
  {
    id: "spyfam",
    title: "间谍过家家",
    titleEn: "Spy x Family",
    category: "allnight",
    genres: ["喜剧", "家庭", "动作"],
    rating: 9.1,
    year: 2022,
    episodes: "共 2 季",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20spy%20father%20with%20short%20blonde%20hair%2C%20an%20assassin%20mother%20and%20a%20psychic%20daughter%20with%20pink%20hair%20standing%20as%20a%20happy%20family%2C%20family%20comedy%20anime%2C%20warm%20red%20and%20cream%20tone%2C%20cheerful%20illustration&width=600&height=900&seq=xh-spyfam&orientation=portrait",
    description:
      "顶尖间谍、职业杀手、读心超能力女孩，三个各怀秘密的人组成了「临时家庭」。温馨搞笑又带点谍战刺激，全家老少都能看。",
    tags: ["搞笑", "温馨", "家庭", "治愈"],
  },
  {
    id: "chainsaw",
    title: "电锯人",
    titleEn: "Chainsaw Man",
    category: "allnight",
    genres: ["战斗", "黑暗", "热血"],
    rating: 8.9,
    year: 2022,
    episodes: "12 话",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20poster%20of%20a%20wild%20boy%20with%20a%20chainsaw%20for%20a%20head%20in%20a%20rain%20soaked%20night%20city%2C%20dark%20action%20anime%2C%20warm%20red%20and%20charcoal%20tone%2C%20gritty%20dynamic%20illustration&width=600&height=900&seq=xh-chainsaw&orientation=portrait",
    description:
      "为还清债务与恶魔签订契约的电次，化身「电锯人」加入公安恶魔猎人。藤本树式的荒诞、血浆与浪漫混在一起，越疯越上头。",
    tags: ["战斗", "暗黑", "燃", "上头"],
  },
];

export const genreOptions: string[] = [
  "热血",
  "战斗",
  "治愈",
  "剧情",
  "奇幻",
  "科幻",
  "恋爱",
  "搞笑",
  "悬疑",
  "运动",
  "日常",
  "催泪",
  "冒险",
  "智斗",
  "单元剧",
];

export function getCategory(id: string): Category | undefined {
  return categories.find((c) => c.id === id);
}

export function getAnimeById(id: string): AnimeItem | undefined {
  return animeList.find((a) => a.id === id);
}

export function getByCategory(category: string): AnimeItem[] {
  return animeList.filter((a) => a.category === category);
}